import styled, { css } from "styled-components";
import { zIndex } from "./constants";
import { calcEmFromPx } from "./utils";

export const DebugPageContainer = styled.div`
  padding: 32px;
`;

export const SharedSidebarCss = () => css`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  min-height: 100%;
  height: 100%;
  padding: 0 ${calcEmFromPx(16)}rem 0;
  align-items: center;
  align-self: flex-start;
`;

export const SharedSidebarFixedFadeCss = css`
  position: fixed;
  min-height: 100%;
  z-index: ${zIndex.negativeLevel};
`;

export const HandleTextOverflow = css`
  /* stylelint-disable */
  display: -webkit-box;
  /* stylelint-enable */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BuyButtonBackgroundColorWithStates = css`
  background: linear-gradient(315deg, #0bc4e2 0%, #2c8cc2 100%);
  &:not(.loading):hover {
    background: ${({ theme }) => theme.color_btn_buy_bg__hover};
  }
  &:not(.loading):active {
    background: ${({ theme }) => theme.color_btn_buy_bg__active};
  }
`;

export const PrimaryModalButtonColorsWithStates = css`
  color: ${({ theme }) => theme.color_btn_modal_primary_text};
  background: ${({ theme }) => theme.color_btn_modal_primary_bg};
  &:not(.loading):hover {
    color: ${({ theme }) => theme.color_btn_modal_primary_text__hover};
    background: ${({ theme }) => theme.color_btn_modal_primary_bg__hover};
  }
  &:not(.loading):active {
    color: ${({ theme }) => theme.color_btn_modal_primary_text__active};
    background: ${({ theme }) => theme.color_btn_modal_primary_bg__active};
  }
`;

export const PrimaryMobileModalButtonColorsWithStates = css`
  color: ${({ theme }) => theme.color_btn_mobile_modal_primary_text};
  background: ${({ theme }) => theme.color_btn_mobile_modal_primary_bg};
  &:not(.loading):hover {
    color: ${({ theme }) => theme.color_btn_mobile_modal_primary_text__hover};
    background: ${({ theme }) => theme.color_btn_mobile_modal_primary_bg__hover};
  }
  &:not(.loading):active {
    color: ${({ theme }) => theme.color_btn_mobile_modal_primary_text__active};
    background: ${({ theme }) => theme.color_btn_mobile_modal_primary_bg__active};
  }
`;

export const SecondaryModalButtonColorsWithStates = css`
  color: ${({ theme }) => theme.color_btn_modal_secondary_text};
  background: ${({ theme }) => theme.color_btn_modal_secondary_bg};
  &:not(.loading):hover {
    color: ${({ theme }) => theme.color_btn_modal_secondary_text__hover};
    background: ${({ theme }) => theme.color_btn_modal_secondary_bg__hover};
  }
  &:not(.loading):active {
    color: ${({ theme }) => theme.color_btn_modal_secondary_text__active};
    background: ${({ theme }) => theme.color_btn_modal_secondary_bg__active};
  }
`;

export const SecondaryMobileModalButtonColorsWithStates = css`
  color: ${({ theme }) => theme.color_btn_mobile_modal_secondary_text};
  background: ${({ theme }) => theme.color_btn_mobile_modal_secondary_bg};
  &:not(.loading):hover {
    color: ${({ theme }) => theme.color_btn_mobile_modal_secondary_text__hover};
    background: ${({ theme }) => theme.color_btn_mobile_modal_secondary_bg__hover};
  }
  &:not(.loading):active {
    color: ${({ theme }) => theme.color_btn_mobile_modal_secondary_text__active};
    background: ${({ theme }) => theme.color_btn_mobile_modal_secondary_bg__active};
  }
`;
